import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeBase } from './office.base';

export const OfficeProduction = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.PRODUCTION);
const config = OfficeProduction;
config.extend(OfficeBase);

OfficeProduction.set('config.key', 'arn:aws:kms:us-east-1:487538251179:key/af5e8a86-6d0f-4f02-b7fa-080e081ba0c8');
OfficeProduction.set('config.store', 'production');
OfficeProduction.set('vendor.google.maps', 'AIzaSyAxyXdFD_QcwjT9O9vJVSoJYnpc4IRc_OM');
OfficeProduction.set('vendor.google.analytics', 'UA-73934200-4');
OfficeProduction.set('vendor.google.tagmanager', 'GTM-PFB5TL7');
OfficeProduction.set('vendor.google.mapsReleaseChannel', 'quarterly');
